import React from "react"

function card(props) {
  const { cardTitle, cardSubtitle, link, demo, cardImage } = props
  let demoNode = null;
  if(demo)  demoNode = <a href={demo} target="_blank" rel="noopener noreferrer" className="card-link">
    Demo
  </a>
  return (
    <div className="col-lg-4">
      <div className="card mx-3 my-5">
        {(cardImage) ? 
        <div className="embed-responsive embed-responsive-16by9">
          <img src={cardImage} className="card-img-top fixed-top embed-responsive-item"></img>
        </div> 
        : null
        }
        <div className="card-body">
          <h2 className="card-title">{cardTitle}</h2>
          <p className="card-text">{cardSubtitle}</p>
          <a href={link} target="_blank" rel="noopener noreferrer" className="card-link">
            Code
          </a>
          {demoNode}
        </div>
      </div>
    </div>
  )
}

export default card
